module.exports = __webpack_public_path__ + "fonts/icomoon.cec483e8.eot";